import { useEffect, useState } from 'react';

/**
 * Returns a copy of `value` that only updates after `delay` ms without changes.
 * Used to keep fast-changing UI (typing, sliders) from firing a query per event.
 */
export function useDebouncedValue<T>(value: T, delay = 250): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
